<template>
    <div 
      class="threeBtn"
      :style="{
        width: windowSize.width > 700 ? (windowSize.width*0.8 + 'px') : (windowSize.width*0.95 + 'px'),
      }"
    >
        <ReturnIcon
          v-model   = "dataArray"
          :dataArray='[]'
          :search="false"
        />
        
        <div 
          class="threeBtnBox"
          v-if="windowSize.width*0.8 > 1000"
        >
            <ButtonThree 
                type="haloBtn" 
                width="80px"
                height="80px" 
                bgColor='rgb(171, 2, 185)'
                round='100%'
                :autofocus='true'
            >haloBtn</ButtonThree>
            <ButtonThree 
                width="300px"
                type="threeBtn" 
                bgColor="#0ba9f7"
                threeTit="threeTit"
            ></ButtonThree>
            <ButtonThree 
                width="300px"
                round='8px'
            >Hover me I'm awesome</ButtonThree>
            
        </div>
        <div 
          class="messagebox"
          :style="{
            padding: windowSize.width > 700 ? '5%' : ' 10% 5%',
          }"
        >
            <h3 style="width: 100%;">vue-3d-button</h3>
            <div>
                <a href="https://github.com/wei-zhe/vue-mind-mapping" target="_blank">
                <i class="iconPosition icon-github"></i> https://github.com/wei-zhe/vue-3d-button
                </a>
            </div>
            <div style="width: 100%;">
                <p>一些3d以及特殊效果的按钮</p>
                <p>## 安装</p>
                <pre style="
                        background: #282c34;
                        color: #ff9401;
                        padding-left: 10px;
                ">
                    npm install vue-3d-button
                </pre>
                <p>## 使用</p>
                <pre style="
                        background: #282c34;
                        color: #ff9401;
                        padding-left: 10px;
                ">
    
    import ButtonThree from 'vue-3d-button'
   
    Vue.use(ButtonThree)

    "<""ButtonThree"' 
        type="haloBtn" 
        width="80px"
        height="80px" 
        bgColor="rgb(171, 2, 185)"
        round="100%"
        :autofocus="true"
    >haloBtn'"</"ButtonThree>"
                </pre>
                <div class="highlight">
                    <h3>type（String）</h3>
                    <p>按钮的样式 colorful / threeBtn / haloBtn</p>
                    <h3>width， height（String）</h3>
                    <p>可自定义宽高，默认：auto</p>
                    <h3>round （String）</h3>
                    <p>可以自定义圆角，默认：2em</p>
                    <h3>nativeType（String）</h3>
                    <p>原生type属性 button / submit / reset</p>
                    <h3>bgColor（String）</h3>
                    <p>背景颜色 默认：'rgba(247, 35, 89, 1)' 在colorful类型下暂且只支持 rgba，其他情况支持background的所有属性</p>
                    <h3>fontColor（String）</h3>
                    <p>文字颜色 '#fff'</p>
                    <h3>fontSize（String）</h3>
                    <p>文字大小，默认：'1em'</p>
                    <h3>threeTit（String）</h3>
                    <p>3d按钮文案</p>
                    <h3>colorful（String）</h3>
                    <p>colorful按钮的hover色 默认：'#4405f7'</p>
                    <h3>autofocus（Boolean）</h3>
                    <p>是否默认聚焦</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pages from '../mixins/pages.vue'

export default {
  name: 'threeBtn',
  mixins: [Pages],
  data (){
    return {
     
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.threeBtn{
    max-width: 1000px;
    margin: 0 auto;
    position: relative;
    background: #fff;
    border-radius: 6px 6px 3px 3px;

    .threeBtnBox {
        position: relative;
        width: 500px;
        height: 500px;
        margin: auto;
        padding-top: 50px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
    }

    .messagebox{
        display: flex;
        flex-flow: wrap;
        width: 90%;
        min-height: 50px;
        background: #ddd;
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 50px;
        text-align: left;
    }
  
}
</style>
